import { computed, Injectable, Signal } from '@angular/core';
import { IIdentityData, IIdentityModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { IdentityActions, IdentitySelectors, IIdentityState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class IdentityStore extends StateAccessService<IIdentityState> {
  readonly state$: Observable<IIdentityState>;

  readonly data$$: Signal<IIdentityData>;
  readonly model$$: Signal<IIdentityModel>;
  readonly opportunityId$$: Signal<number>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(IdentitySelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(IdentitySelectors.data);
    this.opportunityId$$ = computed(() => this.data$$()?.opportunityID);
  }

  dispatchIdentityReset() {
    this.stateFacade.dispatch(IdentityActions.reset());
  }
  dispatchUpdateModel({ model }: { model: IIdentityModel }) {
    this.stateFacade.dispatch(IdentityActions.updateModel({ model }));
  }
  dispatchIdentitySubmit({ model }: { model: IIdentityModel }) {
    this.stateFacade.dispatch(IdentityActions.submit({ model }));
  }
  dispatchIdentitySubmitSuccess({ model, data }: { model: IIdentityModel; data: IIdentityData }) {
    this.stateFacade.dispatch(IdentityActions.submitSuccess({ model, data }));
  }
  dispatchIdentityLoadSuccess({ data }: { data: IIdentityData }) {
    this.stateFacade.dispatch(IdentityActions.loadSuccess({ data }));
  }
}
